import React from "react";
import { useTranslation } from "react-i18next";
import { ArrowUpRight } from "lucide-react";
import { useNavigateWithLock } from "../hooks/useNavigateWithLock";

const AnnouncementBanner: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigateWithLock();

  const handleAnnouncementClick = () => {
    navigate("/help-centers");
  };

  return (
    <div
      className="hover:animate-pulse cursor-pointer mb-6 w-fit mx-auto rounded-full border border-blue-300/60 bg-blue-100 flex items-center overflow-hidden text-xs"
      onClick={handleAnnouncementClick}
    >
      {/* Info Label */}
      <div className="flex-shrink-0 bg-white px-2 py-0.5 border-r ml-1 my-0.5 rounded-full">
        <span className="text-xs font-medium text-blue-600">{t('announcementBanner.label')}</span>
      </div>
      {/* Main Message */}
      <div className="flex-1 px-4 py-0.5">
        <p className="font-medium text-blue-600">
          {t('announcementBanner.message')}
        </p>
      </div>
      {/* Arrow Icon */}
      <div className="flex-shrink-0 px-3 py-0.5">
        <div className="rounded-full bg-blue-100/60 p-1">
          <ArrowUpRight className="h-4 w-4 text-blue-600" />
        </div>
      </div>
    </div>
  );
};

export default AnnouncementBanner;
